// extracted by mini-css-extract-plugin
export default {"mark":"hHRaa"};